import { ORDER_STATUS } from "api/orders/enums";
import { OrderStatusToDisplayType } from "views/orders/components/useGroupedTradeOrdersByStatus";

export const getNameFromBackendTranslations = (
  fallbackTranslation: string,
  locale: string,
  backendTranslationsMap: Record<string, string> = {}
) => {
  return (
    backendTranslationsMap[locale.replace("-", "_")] || fallbackTranslation
  );
};

export const getShortLocale = (locale: string) => {
  return locale.split("-")[0];
};

export const getConvertLocale = (locale: string) => {
  return locale.replace("-", "_");
};

export const getTransactionColor = (
  amountEffect: number,
  cashFlowEffect: number
) =>
  amountEffect > 0 && cashFlowEffect < 0
    ? ("blue" as const)
    : amountEffect < 0 && cashFlowEffect > 0
    ? ("red" as const)
    : amountEffect === 0 && cashFlowEffect > 0
    ? ("green" as const)
    : ("gray" as const);

export const getOrderColor = (orderStatus: OrderStatusToDisplayType) => {
  switch (orderStatus) {
    case ORDER_STATUS.Pending:
      return "blue";
    case ORDER_STATUS.Open:
      return "blue";
    case ORDER_STATUS.Accepted:
      return "green";
    case ORDER_STATUS["In execution"]:
      return "gray";
    case ORDER_STATUS.Cancelled:
      return "red";
    default:
      return "gray";
  }
};
